module.exports = __webpack_public_path__ + "static/media/giphy.a651bf88.gif";